import { lib } from '@giscube/geoportal'
const L = lib.L

class MapiaPano {
  constructor (map, color) {
    this.map = map
    const options = this.options = {
      pointStyle: { color: 'white', weight: 1, fillColor: color, fillOpacity: 1, radius: 0.1, interactive: false },
      centralPointStyle: { color: 'white', weight: 4, fillColor: color, fillOpacity: 1, radius: 8 },
      polygonStyle: { color: color, weight: 0, fillColor: color, fillOpacity: 0.5, interactive: false },
      lenght: 20,
      angle: (Math.PI / 4.8)
    }

    this.latLng = { lat: null, lng: null }
    this.head = null
    this.headFrom = null
    this.geometry = {
      point: null,
      centralPoint: null,
      polygon: null
    }

    this.callBackOnMove = function (head) {}
    L.setOptions(this.options, options)
  }

  getHead = function () {
    const head = this.head * 180 / Math.PI
    const headFrom = this.headFrom
    return { head, headFrom }
  }

  setLatLng = function (latLng, head, from) {
    this.clearGeometry()

    this.latLng = latLng
    this.head = head * Math.PI / 180
    this.headFrom = from

    this._drawPano(true)
  }

  setPosByPoints = function (latLng, targetLatLng, from) {
    this.clearGeometry()

    this.latLng = latLng
    this.head = -Math.atan2((targetLatLng[1] - latLng[1]), (targetLatLng[0] - latLng[0])) + (Math.PI / 2)
    this.headFrom = from

    this._drawPano(true)
  }

  getTargetPoint = function (distance) {
    // Convertir this.latLng a metres i lenht a metres
    // eslint-disable-next-line
    var latlngObject = new L.latLng(this.latLng.lat, this.latLng.lng)
    var utmLatlng = L.Projection.Mercator.project(latlngObject)

    var targetX = utmLatlng.x + distance * Math.cos(this.head)
    var targetY = utmLatlng.y + distance * Math.sin(this.head)

    var utmTarget = new L.Point(targetX, targetY)

    var calulatePoint = L.Projection.Mercator.unproject(utmTarget)

    return [calulatePoint.lat, calulatePoint.lng]
  }

  setOrientation = function (head, from) {
    head = head * Math.PI / 180
    if (head < 0) {
      head += 2 * Math.PI
    } else if (head > 2 * Math.PI) {
      head -= 2 * Math.PI
    }
    this.head = head
    this.headFrom = from
    this._drawPano(true)
  }

  clearGeometry = function () {
    if (this.geometry.centralPoint) { this.map.removeLayer(this.geometry.centralPoint) }
    if (this.geometry.point) { this.map.removeLayer(this.geometry.point) }
    if (this.geometry.polygon) { this.map.removeLayer(this.geometry.polygon) }

    this.map.removeEventListener('mouseup')
    this.map.removeEventListener('mousemove')
    this.map.removeEventListener('zoom')
  }

  _drawPano = function (create) {
    if (Number.isNaN(this.head)) { return }

    // Descomentar tot el block, només ho hem canviat per pintar el punt origen
    var self = this

    var centralPoint
    var rightPoint
    var leftPoint
    var lenght = this.options.lenght * Math.pow(2, 19) / Math.pow(2, this.map.getZoom())
    var alpha = this.options.angle
    var laterall = lenght / Math.cos(alpha)
    // Convertir this.latLng a metres i lenht a metres
    // eslint-disable-next-line
    var latlngObject = new L.latLng(this.latLng.lat, this.latLng.lng)
    var utmLatlng = L.Projection.Mercator.project(latlngObject)

    var utmCentraltPoint = new L.Point((utmLatlng.x + lenght * Math.cos(this.head)), (utmLatlng.y + lenght * Math.sin(this.head)))

    var utmLeftPoint = new L.Point((utmLatlng.x + laterall * Math.cos(alpha + this.head)), (utmLatlng.y + laterall * Math.sin(alpha + this.head)))

    var utmRightPoint = new L.Point((utmLatlng.x + laterall * Math.cos(this.head - alpha)), (utmLatlng.y + laterall * Math.sin(this.head - alpha)))

    // Convertir a latlng
    centralPoint = L.Projection.Mercator.unproject(utmCentraltPoint)
    leftPoint = L.Projection.Mercator.unproject(utmLeftPoint)
    rightPoint = L.Projection.Mercator.unproject(utmRightPoint)

    var centralArray = []
    var leftPointArray = []
    var rightPointAray = []

    centralArray.push(centralPoint.lat)
    centralArray.push(centralPoint.lng)

    leftPointArray.push(leftPoint.lat)
    leftPointArray.push(leftPoint.lng)

    rightPointAray.push(rightPoint.lat)
    rightPointAray.push(rightPoint.lng)

    if (this.geometry.point) { this.map.removeLayer(self.geometry.point) }
    if (this.geometry.polygon) { this.map.removeLayer(self.geometry.polygon) }

    this.geometry.polygon = L.polygon([this.latLng, rightPointAray, leftPointArray, this.latLng], this.options.polygonStyle)
    this.geometry.point = L.circleMarker(this.latLng, this.options.pointStyle)

    this.geometry.polygon.addTo(this.map)
    this.geometry.point.addTo(this.map)

    if (create) {
      if (this.geometry.centralPoint) { self.map.removeLayer(this.geometry.centralPoint) }

      this.geometry.centralPoint = L.circleMarker(centralPoint, this.options.centralPointStyle)
      this.geometry.centralPoint.addTo(this.map)

      self.map.removeEventListener('mouseup')
      this.geometry.centralPoint.on({
        mousedown: function () {
          self.map.on('mousemove', function (e) {
            self.headFrom = 'panoOrientation'
            self.map.dragging.disable()
            var center = self.geometry.point.getLatLng()
            let head = -Math.atan2((e.latlng.lng - center.lng), (e.latlng.lat - center.lat)) + (Math.PI / 2)
            if (head < 0) {
              head += 2 * Math.PI
            } else if (head > 2 * Math.PI) {
              head -= 2 * Math.PI
            }
            self.head = head
            self.callBackOnMove(-self.head + Math.PI / 2)
            self._drawPano(false)
          })
        }
      })
      self.map.on('mouseup', function (e) {
        self.map.removeEventListener('mousemove')
        self.map.dragging.enable()
        // e.originalEvent.stopPropagation()
        e.originalEvent.preventDefault()
      })
      self.map.on('zoom', function () {
        self._drawPano(false)
      })
    } else {
      this.geometry.centralPoint.setLatLng(centralPoint)
      this.geometry.centralPoint.bringToFront()
    }
  }
}

export default MapiaPano
